<template>
  <v-card
    elevation="0"
    outlined
    min-width="318"
    class="py-4 px-4 no-background mb-3 card cursor-pointer"
    data-testid="card-entityCard"
  >
    <v-progress-linear
      :active="isImporting"
      class="ma-0 pa-0"
      indeterminate
      color="blue"
    />

    <div class="d-flex" @click="$emit('select')">
      <div
        class="d-flex flex-column justify-space-between"
        style="min-width: 50%; min-height: 115px;"
      >
        <div class="d-flex align-start flex-column">
          <EntityChip v-if="revType" :entityType="revType" :date="createdAtText" />

          <p
            v-snip="{ lines: 2, mode: 'css' }"
            class="body-2 blue-grey--text text--darken-3 mt-3 mb-2 font-weight-medium"
          >
            {{ rev.name }}
          </p>
        </div>

        <div v-if="hasAuthor" class="d-flex">
          <ChipAvatar :account="author" class="pa-0 ma-0" />
        </div>
      </div>

      <div
        class="d-flex flex-column justify-center align-end"
        style="width: 50%;"
      >
        <ImageMedia
          v-if="hasMedia"
          showEmptyState
          class="rounded-lg"
          style="width: 112px; height: 112px; border:0"
          :revMedia="revMedia"
        />

        <ImageEmptyState v-else icon="mdi-image-outline" class="h-100" />
      </div>
    </div>
    <v-card-actions class="pa-0 mt-5 mb-0">
      <Button
        dark
        block
        size="small"
        data-testid="card-button-import"
        icon="mdi-tray-arrow-down"
        :text="$t('cards.import')"
        @click="$emit('import')"
      />
    </v-card-actions>
  </v-card>
</template>

<script>
import _ from 'lodash'
import { utils } from 'frontend-js-shared'
import constants from '@/constants'

import Button from '@/ui/shared/components/Button.vue'
import ImageEmptyState from '@/ui/shared/components/ImageEmptyState.vue'
import ImageMedia from '@/ui/shared/components/ImageMediaView.vue'
import { IMAGE_SIZES } from 'rever-media-sdk'
import ChipAvatar from '@/ui/shared/components/ChipAvatar.vue'
import EntityChip from '@/ui/shared/components/EntityChip.vue'

const { dates } = utils

export default {
  name: 'Card',

  components: {
    Button,
    ImageEmptyState,
    ImageMedia,
    ChipAvatar,
    EntityChip,
  },

  props: {
    rev: {
      type: Object,
      required: true,
    },
    isImporting: {
      type: Boolean,
      default: false,
    },
  },

  data: () => {
    return {
      constants,
      show: false,
      selectedRev: null,
      IMAGE_SIZES,
    }
  },

  computed: {
    revId() {
      return this.rev.id ?? ''
    },

    revType() {
      return this.rev.entityType ?? ''
    },

    organizationId() {
      return this.rev.organization ?? ''
    },

    metadata() {
      return this.rev.metadata ?? ''
    },

    revMedia() {
      return this.rev?.image ?? false
    },

    hasMedia() {
      return !_.isEmpty(this.revMedia)
    },

    author() {
      return this.rev?.team?.author ?? this.rev?.createdBy
    },

    hasAuthor() {
      return !_.isEmpty(this.author)
    },

    createdAtText() {
      return this.rev?.createdAt ? dates.formatDate(this.rev.createdAt, 'MMM D, YY') : ''
    },
  },
}
</script>
<style lang="scss" scoped>
.card:hover {
  border: 0;
  background-color: var(--v-blue-grey-lighten3);
  & .chip {
    background-color: var(--v-blue-grey-lighten3) !important;
  }
}

.card:hover .imageEmptyStateStyle {
  background-color: var(--v-blue-grey-lighten2) !important;
}
</style>
